import React from "react";
import { useCompanySettings } from "../hooks/useCompanySettings";
import i18n from "../locale/i18n";
import { classNames } from "../utils";

export default function Footer() {
  const { showDataProviderInfo, showDataDelayInfo, showDisclaimerInfo, showPrivacyPolicyInfo = true } = useCompanySettings();
  const { language, termsOfServiceURL, cookiePolicyURL, suppliedByLanguage, eurolandURL, privacyPolicyURL } =
    window.appSettings;
  const euroland = eurolandURL || "https://www.euroland.com/";
  const termsOfService = termsOfServiceURL || "https://tools.eurolandir.com/legal/terms/";
  const cookiePolicy = cookiePolicyURL || "https://tools.eurolandir.com/legal/cookie/";
  const privacyPolicy = privacyPolicyURL || "https://tools.eurolandir.com/legal/privacy/";
  return (
    <footer
      className={classNames("footer", {
        "has-provider-info": showDataProviderInfo,
        "has-dataDelay-info": showDataDelayInfo,
        "has-disclaimer-info": showDisclaimerInfo,
      })}
    >
      <div className="footer-content">
        {showDataProviderInfo && (
          <p className="footer-content_primary">
            {i18n.translate("supplyBy")}
            <a
              target="_blank"
              rel="noreferrer"
              className="footer__supplierInfoLink"
              href={`${euroland}?SelectLanguage=${suppliedByLanguage || "english"}`}
            >
              {i18n.translate("euroland_com")}
            </a>
          </p>
        )}

        <div className="footer-content_secondary">
          {showDataDelayInfo && <p>{i18n.translate("dataDelay")}</p>}
          {showDisclaimerInfo && (
            <p>
              <a href={`${termsOfService}?lang=${language}`} target="_blank" rel="noreferrer">
                {i18n.translate("termsOfService")}
              </a>
              {" | "}
              <a href={`${privacyPolicy}?lang=${language}`} target="_blank" rel="noreferrer">
                {i18n.translate("privacyPolicy")}
              </a>
              {" | "}
              <a href={`${cookiePolicy}?lang=${language}`} target="_blank" rel="noreferrer">
                {i18n.translate("cookiePolicy")}
              </a>
            </p>
          )}
        </div>
      </div>
    </footer>
  );
}
